export default class Currency {
  #symbol;
  #isoCode;

  get symbol() {
    return this.#symbol;
  }

  get isoCode() {
    return this.#isoCode;
  }

  get hasSymbol() {
    return this.#symbol !== "";
  }

  constructor(symbol = "", isoCode = "") {
    this.#symbol = symbol;
    this.#isoCode = isoCode;
  }
}